import { createTheme, SelectChangeEvent, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { MenuItem } from "react-pro-sidebar";
import MenuMui from '@mui/material/Menu';
import MenuItemMui from '@mui/material/MenuItem';
import { useNavigate } from "react-router-dom";
import '../../Sidebar/Prosidebar.css'
import { MouseEvent } from "react";
import { CurrentPage } from "./ContentSideList";

export interface ISelectList {
  id: string;
  internalName: string | undefined;
  name: string;
}

export interface ContentbarProps<T>{
    children: string;
    title?: string;
    conditional?: boolean;
    fill?: string;
    footer?: boolean;
    icon?: JSX.Element;
    onClick?: (e: MouseEvent<HTMLElement, globalThis.MouseEvent>) => void
    handleChange?: (event: React.MouseEvent) => void,
    isSelect:boolean;
    disabled: boolean;
    renderOption: boolean;
    setHovered?: (set: { id: string, color: string }) => void;
    setSelected?: (set: { id: string, color: string }) => void;
    isWorkspace?: boolean;

    selectionList?: T[];
    isSelectField?: boolean,
    anchorElSelect?: HTMLElement | null,
    handleClickSelect?: (event: React.MouseEvent<HTMLButtonElement>) => void,
    handleCloseSelect?: () => void,
    nameOrg?: string,
    onChangeSelection?: (selectEvent: SelectChangeEvent | undefined, mouseEvent?: MouseEvent<HTMLLIElement, globalThis.MouseEvent>) => void,
    openSelect?: boolean,
    selectList?: T[];
    selectValue?: string;
    isCollapsed?: boolean;
    currentPage: CurrentPage;
    isCurrentPage?: boolean;
    isAdminConsolePage?: boolean;
    isNameOption?: boolean;
}

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          backgroundColor: '#E9EFF4',
          color: '#22638D',
          height: "21px",
          textAlign: "left",
          font:" normal normal normal 14px Segoe UI",
          opacity: 1,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: "2px 2px 5px rgba(0, 0, 0, 0.2)"
        },
        arrow: {
          color: '#E9EFF4',
        },
      },
    },
  },
});

export const ContentSideComp: React.FC<ContentbarProps<ISelectList>> = ({
  children,
  icon,
  onClick,
  isCollapsed,
  disabled,
  renderOption,
  isCurrentPage,
  isAdminConsolePage,
  isNameOption,
  setHovered,
  setSelected,
  footer
}: ContentbarProps<ISelectList>) => {


  function styleHandler() {
    if (isCurrentPage) {
      return "currentPage"
    }

    if (isAdminConsolePage) {
      return "currentAdmin"
    }

    return ""
  }

    return(
      <>     
        { renderOption && (
          <ThemeProvider theme={theme}>
            <Tooltip title={isCollapsed && children} disableInteractive placement="bottom-end" arrow PopperProps={{
              popperOptions: {
                modifiers: [0, 80]
              }
            }}>
                <MenuItem
                  className={`${isCurrentPage ? isAdminConsolePage ? 'currentAdmin' : 'currentPage' : ''} ${children == "Admin console" && "adminConsole"}`.trim()}
                  icon={icon}
                  onClick={(e) => {
                    onClick!(e)
                    setSelected!({
                      id: children,
                      color: "#22638D"
                    });
                  }}
                >
                    { !isCollapsed && (
                      <Typography
                        component="span"
                        fontSize="14px"
                        fontFamily="Segoe UI"
                        fontWeight={isNameOption ? "600" : "400"}
                      >
                        {children}
                      </Typography>
                    ) }
                </MenuItem>
            </Tooltip>
          </ThemeProvider>
        ) }
      </>
    )
  }